"use client";
import CommonButton from "@/components/common/common-button/common-button";
import ScreenLayout from "@/components/layout/screen-layout";
import {
  LogoMyCasaFriends,
  MyCasaFriendsCaseStudyHeroThumbnail,
} from "@/lib/images";
import Image from "next/image";
import { useEffect, useRef } from "react";

function HeroSectionMycasaFriends() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log("Video autoplay failed:", error);
      });
    }
  }, []);
  return (
    <ScreenLayout
      className="pt-28 md:pt-48 pb-10 md:pb-20 h-screen"
      outerClassName="relative"
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg,rgba(0,0,0,0.41)_0%,rgba(0,0,0,0.5)_50%,rgba(0,0,0,0.2)_100%)",
        }}
      />
      <Image
        src={MyCasaFriendsCaseStudyHeroThumbnail}
        alt="Hero Video"
        className="absolute top-0 left-0 w-full h-full object-cover"
      />
      {/* Video Background */}
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source
          src="/images/case-studies/event-hosting-solution/mycasa-friends-case-study-hero-video.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <div className="flex flex-col items-center justify-center h-full z-10 relative">
        {/* Logo */}
        <div className="w-20 sm:w-24 md:w-28 lg:w-32 z-10">
          <Image
            src={LogoMyCasaFriends}
            alt="AtMyCasa Logo"
            className="w-full object-contain"
          />
        </div>

        {/* Heading */}
        <h1
          className="text-center text-white font-semibold pt-6 sm:pt-8 z-10 
                 text-3xl sm:text-4xl md:text-5xl lg:text-[58px] max-w-full sm:max-w-2xl md:max-w-4xl"
        >
          Turning Every Gathering Into a{" "}
          <span className="text-[#25A244]">Memorable Experience</span>
        </h1>

        {/* Paragraph */}
        <p
          className="text-center text-white opacity-80 font-medium py-5 sm:py-6 md:py-7 
                text-sm sm:text-base md:text-lg max-w-md sm:max-w-2xl md:max-w-3xl z-10"
        >
          Food. Friends. Events. We transformed AtMyCasa into a seamless
          event booking experience—where every gathering becomes a memory worth
          sharing.
        </p>

        {/* Button */}
        <CommonButton
          href="/contact-us"
          className="z-10 mt-2 sm:mt-4"
          variant="outline"
          size="md"
        >
          Build Similar App
        </CommonButton>
      </div>
    </ScreenLayout>
  );
}

export default HeroSectionMycasaFriends;
